import { render, staticRenderFns } from "./KfPopUp.vue?vue&type=template&id=3bf236f2&scoped=true&"
import script from "./KfPopUp.vue?vue&type=script&lang=js&"
export * from "./KfPopUp.vue?vue&type=script&lang=js&"
import style0 from "./KfPopUp.vue?vue&type=style&index=0&id=3bf236f2&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bf236f2",
  null
  
)

export default component.exports